import React, { useState } from "react";
import { Button, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { DialogContent, Dialog, DialogTitle, DialogActions, DialogContentText } from '@mui/material';

export const ConfirmationPopover = (props) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

       const handleConfirm = async () => {
        if (isSubmitting) return; 
        setIsSubmitting(true);
        try {
            await props.onConfirm();
        } catch (error) {
            console.error("API call failed:", error);
        } finally {
            setIsSubmitting(false); 
        }
    };

    return (
        <Dialog maxWidth='xs' fullWidth open={props.onOpen}>
            <DialogTitle id="alert-dialog-title">
                Confirm {props.action}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {props?.specialMessage && <>{props?.specialMessage}<br />
                        <br /></>}
                    Are you sure you want to {props.actionText ? props.actionText : props.action?.toLowerCase()}?

                </DialogContentText>
                {props?.action == "Reject Invoice" && <FormControlLabel
                    sx={{ mt: 1 }}
                    control={
                        <Checkbox checked={props.raiseTicketFlag} onChange={props.handleRaiseTicket} />
                    }
                    label="Raise Ticket"
                />}

            </DialogContent>
            <DialogActions>
                  <Button onClick={props.onClose} disabled={isSubmitting}>
                    Cancel
                </Button>
                <Button onClick={handleConfirm} disabled={isSubmitting}>
                    {isSubmitting ? "Processing..." : "Confirm"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
